// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"002abeb8","952":"4ed23403"}[chunkId] + ".chunk.js";
};